/**
 * @description 登录日志 loginLog
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const loginLogBiz = new Logic()

loginLogBiz.loginLogFindPage = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.loginLog.loginLogFindPage,
    data: data
  })
}

export default loginLogBiz
